import { parse } from 'hub-http/helpers/params';
import { fromJS } from 'immutable';
export const getQueryParams = () => {
  const queryString = window.location.search.replace(/^\?/, '');
  const queryMap = fromJS(parse(queryString));
  return queryMap.filter(value => value != null);
};